module.exports = __webpack_public_path__ + "img/theme7.fb750c71.png";